import React from "react";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section className="hero-section d-flex align-items-center justify-content-center">
      <div className="container text-center text-white mx-3">
        <h2 className="fw-bold mb-3">
         Get Expert Advice and the Perfect<br />
Cooling Solution for Your Space.
        </h2>
        <p className="mb-4"><small>
          Beat the heat with solar confidence. Our energy experts are ready to match you with the perfect system for your space, lifestyle, and budget.</small>
        </p>
        <Link to="/contact" className="btn text-white btn-lg" style={{ backgroundColor: '#079000' }}>
          Contact Us
        </Link>
      </div>
    </section>
  );
};

export default HeroSection;
